import { render, staticRenderFns } from "./popupSingle.vue?vue&type=template&id=678bbc79&"
import script from "./popupSingle.vue?vue&type=script&lang=js&"
export * from "./popupSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports